import { OFFICIAL_BOOKING_URL } from "@/lib/data";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * A premium call-to-action strip rendered above the footer on every page,
 * inviting guests to open the full booking page.
 */
export default function ReserveYourStayCTA() {
    return (
        <section
            data-testid="reserve-your-stay-cta"
            className="relative overflow-hidden bg-navy text-ivory"
        >
            <div
                className="absolute inset-0 bg-cover bg-center opacity-30"
                style={{
                    backgroundImage:
                        "url('https://images.pexels.com/photos/37569474/pexels-photo-37569474.jpeg')",
                }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/70 to-navy/60" />
            <div className="relative max-w-5xl mx-auto px-6 lg:px-10 py-24 md:py-32 text-center">
                <div className="text-[11px] uppercase tracking-[0.32em] text-gold flex items-center justify-center gap-3">
                    <span className="w-10 h-[1px] bg-gold" /> Your Escape Awaits <span className="w-10 h-[1px] bg-gold" />
                </div>
                <h2 className="mt-6 font-display text-4xl md:text-6xl lg:text-7xl leading-[1.02]">
                    Come, be <span className="font-serif-italic text-gold">quietly welcomed</span>.
                </h2>
                <p className="mt-6 max-w-2xl mx-auto text-ivory/80 leading-relaxed">
                    Choose your room, review our seasonal rates, and let our concierge team prepare every small kindness of your stay in Ocho Rios.
                </p>
                <Link to="/booking"
                    data-testid="reserve-your-stay-btn"
                    className="mt-10 inline-flex items-center gap-2 btn-gold px-9 py-4 rounded-full"
                >
                    Reserve Your Stay <ArrowRight size={16} />
                </Link>
            </div>
        </section>
    );
}
